<template>
  <div class="strategio-bgmain-view fill-height">
    <strategio-app-bar></strategio-app-bar>
    <v-main class="fill-height">
      <v-container align-items="center">
        <v-row class="strategio-titles-windows">
          <autoservicio-btn-back title-name="Homologacion"></autoservicio-btn-back>
        </v-row>
      </v-container>
      <iframe id='ifrm-homologation' class="strategio-iframe" frameborder="0" :src="url" style="height: 100%; width: 100%;"></iframe>
    </v-main>
  </div>
</template>
<script>
// import Axios from 'axios'
import StrategioAppBar from '../../../components/header-bar/strategio-app-bar.vue'
import AutoservicioBtnBack from '../../../components/autoservicios/autoservicio-btn-back.vue'

export default {
  name: 'show-homologation',
  components: {
    StrategioAppBar,
    AutoservicioBtnBack
  },
  data () {
    return {
      url: 'https://softysi.strategio.cloud/homologacionFecha/8d6135cc-05ee-4492-b866-8cb3e2ab97b7'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/routes/autoservicios/homologation/show-homologation.vue